import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemAvailability } from '../../../utils/get-line-item-availability.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import { toBaseLineItem } from './base-line-item.js';
import { getProductA11yLabel } from './utils/get-product-a11y-label.js';
import { getProductTitle } from './utils/get-product-title.js';

const toRegularCartLineItem = (cartLineItem, intl, settings)=>{
    const imageUrl = getLineItemImageUrl(cartLineItem.legacyProduct.masterData.current.variant, settings.staticsUrl, settings.isBynderImagesEnabled);
    const base = toBaseLineItem(cartLineItem, settings, intl);
    const variant = cartLineItem.legacyProduct.masterData.current.variant;
    let title = getProductTitle(cartLineItem.legacyProduct, intl);
    let subtitle = '';
    switch(cartLineItem.legacyProduct.productType.toLowerCase()){
        case 'solutions':
            title = getLocalizedString(cartLineItem.legacyProduct.masterData.current.name, intl.locale);
            subtitle = `${getAttribute(variant, 'solutionType')}, ${getAttribute(variant, 'volume')}${getAttribute(variant, 'volumeUnit') || 'ml'}`;
            break;
        case 'frames':
            subtitle = `${getAttribute(variant, 'brandModelCode')}, ${intl.getLabel('products.frames.frameOnly.description')}`;
            break;
        case 'ready-readers':
            subtitle = `${intl.getLabel('products.readyreaders.power')}: ${getAttribute(variant, 'power')}`;
            break;
        case 'sunglasses':
        case 'accessories':
            subtitle = getAttribute(variant, 'brandModel');
            break;
    }
    return swcHelpers.objectSpread({}, base, {
        imageUrl,
        subtitle,
        title,
        altText: getProductA11yLabel(cartLineItem, intl),
        sku: cartLineItem.sku,
        type: 'REGULAR'
    }, variant.availability ? {
        availability: getLineItemAvailability(variant.availability)
    } : {});
};

export { toRegularCartLineItem };
//# sourceMappingURL=regular-line-item.js.map
